/**
 * WebApi
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ItemStates = 'NotSpecified' | 'Rating' | 'Decisioning' | 'CommunicationAward' | 'Finished';

export const ItemStates = {
    NotSpecified: 'NotSpecified' as ItemStates,
    Rating: 'Rating' as ItemStates,
    Decisioning: 'Decisioning' as ItemStates,
    CommunicationAward: 'CommunicationAward' as ItemStates,
    Finished: 'Finished' as ItemStates
};

